if (!customElements.get('fc-footer-details')) {
  class FCFooterDetails extends AccordionDetails {
    constructor() {
      super();

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';
      this.setAttribute('aria-controls', this.contentElement.id);
      this.handleBreakpointChange();

      document.addEventListener('matchTablet', this.handleBreakpointChange);
      document.addEventListener('unmatchTablet', this.handleBreakpointChange);
    }

    disconnectedCallback() {
      document.removeEventListener('matchTablet', this.handleBreakpointChange);
      document.removeEventListener('unmatchTablet', this.handleBreakpointChange);
    }

    handleBreakpointChange() {
      this.open = FoxTheme.config.mqlTablet ? this.openDefault : true;
    }
  }

  customElements.define('fc-footer-details', FCFooterDetails, { extends: 'details' });
}
